<div class="batchsMenuContainer" *ngIf="display">
	<button
		class="batchsMenuButton" 
		[matMenuTriggerFor]="batchsMenu"
		[style.color]="iconColor"
		>
		<i class="fa fa-lg fa-gear"></i>
		<span class="batchsCount">{{ batchsCount }}</span>
	</button>
	<mat-menu #batchsMenu="matMenu" xPosition="before" class="batchsMenuPanel">
		<ng-template matMenuContent let-item="item">
			<div *ngFor="let display of batchsDisplays"
				mat-menu-item
				class="batchLine"
				>
				<span
					[style.color]="statusColor[display.batch.status]"
					>
					{{ display.batch.jobExecutionId }}, {{ display.creationDate | date : 'dd/MM/yyyy HH:mm' }}, {{ display.batch.jobName }}, {{ statusLabel[display.batch.status] }}
				</span>
				<a *ngIf="display.batch.status === 'COMPLETED' || display.batch.status === 'FAILED'"
					class="batchActionButton" (click)="onBatchRemoveClicked(display.batch)">
					<i class="fa fa-close"></i>
				</a>
			</div>
			<a
				mat-menu-item
				class="clearActionButton"
				(click)="onClearClicked()"
				>
				R&eacute;initialiser la liste
			</a>
		</ng-template>
	</mat-menu>
</div>
